import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith, switchMap, debounceTime } from 'rxjs/operators';

import { LocationsService, RequireMatch } from '../../../core';

@Component({
  standalone: false,
  selector: 'app-locations',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.scss'],
})
export class LocationsComponent implements OnInit, OnChanges {
  myForm: FormGroup;
  @Input() isColumn: boolean;
  @Input() id: string;
  @Input() isDepartment: boolean;
  @Input() isProvince: boolean;
  @Input() isDistrict: boolean;
  @Input() changeLevel: boolean;
  @Input() data: any = null;
  @Input() localStore;
  @Input() isHistorial: boolean;
  @Input() isModuleNV: boolean;
  @Input() isEditDispatch: boolean;
  @Input() saleChannelZone: string;
  @Output() idDepartment = new EventEmitter<number>();
  @Output() idProvince = new EventEmitter<object>();
  @Output() idDistrict = new EventEmitter<object>();
  listDepartmentAsync: Observable<any[]>;
  listProvinceAsync: Observable<any[]>;
  listDistrictAsync: Observable<any[]>;
  listDepartment: Promise<any[]>;
  listProvince: Promise<any[]> = new Promise(resolve => {
    resolve([]);
  });
  listDistrict: Promise<any[]> = new Promise(resolve => {
    resolve([]);
  });
  isLoaded = false;
  class: string;

  constructor(
    formBuilder: FormBuilder,
    public locationsService: LocationsService,
  ) {
    this.myForm = formBuilder.group({
      department: [null, [RequireMatch]],
      province: [
        {
          value: null,
          disabled: true,
        },
        [RequireMatch],
      ],
      district: [
        {
          value: null,
          disabled: true,
        },
        [RequireMatch],
      ],
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['saleChannelZone'] && !changes['data']) {
      return
    }
    if (this.data && Object.keys(this.data).length) {
      if (this.isModuleNV) {
        this.myForm.controls['department'].setValue(this.data.department);
        if (this.isEditDispatch && this.data.department) {
          this.myForm.controls['department'].disable({
            onlySelf: false,
            emitEvent: false,
          });
        }
      } else {
        this.myForm.setValue({
          department: this.data.department,
          province: this.data.province,
          district: this.data.district ? this.data.district : null,
        });
      }
    } else {
      this.myForm.controls['department'].setValue('');
    }
  }

  ngOnInit() {
    this.myForm.controls['district'].disable({
      onlySelf: false,
      emitEvent: false,
    });
    this.listDepartmentAsync = this.myForm.controls['department'].valueChanges.pipe(
      debounceTime(400),
      startWith<string | any>(''),
      switchMap(change =>
        typeof change === 'string' ? this.filterDepartment(change) : [[]],
      ),
      map(value => {
        const isExistSelect = this.myForm.controls['department'].value;
        this.idDepartment.emit(isExistSelect);
        if (isExistSelect && typeof isExistSelect === 'object') {
          this.locationsService
            .read('province', isExistSelect.id)
            .subscribe((response: any) => {
              if (this.isModuleNV) {
                if (
                  this.data.department &&
                  this.data.province &&
                  this.data.district
                ) {
                  this.myForm.markAsTouched();
                }
              }

              this.listProvince = new Promise(resolve => resolve(response));
              if (
                (!this.isModuleNV && !this.localStore) ||
                (!this.isHistorial && !this.myForm.touched)
              ) {
                this.myForm.controls['province'].setValue('');
              } else {
                if (this.isModuleNV) {
                  if (typeof this.data.province === 'string') {
                    const valueDefault = response.find(
                      item =>
                        item.province.toLowerCase() ===
                        this.data.province.toLowerCase(),
                    );
                    this.myForm.controls['province'].setValue(
                      valueDefault
                        ? {
                            province: valueDefault.province,
                            id: valueDefault.id,
                          }
                        : '',
                    );
                  } else {
                    this.myForm.controls['province'].setValue('');
                  }
                }
              }
              if (!this.isEditDispatch || this.isEditDispatch && !this.data.department) {
                this.myForm.controls['province'].enable({
                  onlySelf: false,
                  emitEvent: false,
                });
              }
            });
        } else {
          this.myForm.controls['province'].disable({
            onlySelf: false,
            emitEvent: false,
          });
          this.listProvince = new Promise(resolve => resolve([]));
          this.myForm.controls['province'].setValue('');
        }
        return value;
      }),
    );
    this.listProvinceAsync = this.myForm.controls['province'].valueChanges.pipe(
      debounceTime(400),
      startWith<string | any>(''),
      switchMap(change =>
        typeof change === 'string' ? this.filterProvince(change) : [[]],
      ),
      map(value => {
        const isExistDepartment = this.myForm.controls['department'].value;
        const isExistProvince = this.myForm.controls['province'].value;
        if (!this.isEditDispatch || this.isEditDispatch && !this.data.department) {
          this.myForm.controls['province'].enable({
            onlySelf: false,
            emitEvent: false,
          });
        }
        this.idProvince.emit({ x: isExistDepartment, y: isExistProvince });
        if (isExistProvince && typeof isExistProvince === 'object') {
          this.locationsService
            .read('district', {
              province: isExistProvince.id,
              department: isExistDepartment.id,
              special_zones: false,
              sub_zones: false,
              filter_actives: false,
              geo_json: false,
              dispatch_enabled: false,
              sale_channel: this.saleChannelZone
            })
            .subscribe((response: any) => {
              this.listDistrict = new Promise(resolve => {
                resolve(response);
              });
              if (
                this.isModuleNV &&
                this.data.department &&
                this.data.province &&
                this.data.district
              ) {
                this.myForm.markAsTouched();
              }
              if (this.isModuleNV) {
                if (!this.isHistorial && !this.myForm.touched) {
                  this.myForm.controls['district'].setValue('');
                } else {
                  if (typeof this.data.district === 'string') {
                    const valueDefault = response.find(
                      item =>
                        item.district.toLowerCase() ===
                        this.data.district.toLowerCase(),
                    );
                    this.myForm.controls['district'].setValue(
                      valueDefault
                        ? {
                            district: valueDefault.district,
                            id: valueDefault.ubigeoCode,
                          }
                        : '',
                    );
                  }
                }
                if (!this.isHistorial) {
                  this.myForm.controls['district'].enable({
                    onlySelf: false,
                    emitEvent: false,
                  });
                }
              }
            });
        } else {
          this.myForm.controls['district'].disable({
            onlySelf: false,
            emitEvent: false,
          });
          this.listDistrict = new Promise(resolve => {
            resolve([]);
          });
          this.myForm.controls['district'].setValue('');
        }
        return value;
      }),
    );
    this.listDistrictAsync = this.myForm.controls['district'].valueChanges.pipe(
      debounceTime(200),
      startWith<string | any>(''),
      switchMap(change =>
        typeof change === 'string' ? this.filterDistrict(change) : [[]],
      ),
      map(value => {
        const isExistDepartment = this.myForm.controls['department'].value;
        const isExistProvince = this.myForm.controls['province'].value;
        const isExistDistrict = this.myForm.controls['district'].value;
        this.idDistrict.emit({
          x: isExistDepartment,
          y: isExistProvince,
          z: isExistDistrict,
        });
        this.disableAlls();
        return value;
      }),
    );
  }

  disableAlls() {
    if (this.isHistorial) {
      this.myForm.disable({
        onlySelf: false,
        emitEvent: false,
      });
    } else {
      if (!this.isEditDispatch || this.isEditDispatch && !this.data.department) {
        this.myForm.controls['department'].enable({
          onlySelf: false,
          emitEvent: false,
        });
      }
    }
  }

transformClass() {
  const x = this.isDepartment;
  const y = this.isProvince;
  const z = this.isDistrict;

  if (this.isColumn) {
    return { 'col-md-12': true };
  } else if (x && y && z) {
    return { 'col-md-4': true };
  } else if ((x && y) || (x && z) || (y && z)) {
    return { 'col-md-6': true };
  } else if (x || y || z) {
    return { 'col-md-12': true };
  } else {
    return { 'col-md-12': true };
  }
}

  filterDepartment(value): Promise<any[]> {
    if (this.listDepartment) {
      return this.listDepartment.then((response: any) => {
        if (
          this.isHistorial &&
          this.myForm.controls['department'].value &&
          typeof this.myForm.controls['department'].value === 'string' &&
          this.isModuleNV
        ) {
          const valueDefault = response.find(
            item =>
              item.department.toLowerCase() ===
              this.data.department.toLowerCase(),
          );
          this.myForm.controls['department'].setValue(
            valueDefault
              ? { department: valueDefault.department, id: valueDefault.id }
              : '',
          );
        }
        return response.filter(item =>
          item.department
            .slice(0, value.length)
            .toLowerCase()
            .includes(value.toLowerCase()),
        );
      });
    } else {
      this.listDepartment = this.locationsService
        ._filterDepartment()
        .pipe(
          map((response: any[]) => {
            if (
              this.isModuleNV &&
              this.data &&
              typeof this.data.department === 'string'
            ) {
              const valueDefault = response.find(
                item =>
                  item.department.toLowerCase() ===
                  this.data.department.toLowerCase(),
              );
              this.myForm.controls['department'].setValue(
                valueDefault
                  ? { department: valueDefault.department, id: valueDefault.id }
                  : '',
              );
            }
            return response;
          }),
        )
        .toPromise();
      return this.listDepartment;
    }
  }

  filterProvince(value): Promise<any[]> {
    if (typeof value !== 'object') {
      return this.listProvince.then((response: any) =>
        response.filter(item =>
          item.province
            .slice(0, value.length)
            .toLowerCase()
            .includes(value.toLowerCase()),
        ),
      );
    }
      return Promise.resolve([]);
  }

  filterDistrict(value): Promise<any[]> {
    if (typeof value !== 'object') {
      return this.listDistrict.then((response: any) =>
        response.filter(item =>
          item.district
            .slice(0, value.length)
            .toLowerCase()
            .includes(value.toLowerCase()),
        ),
      );
    }
      return Promise.resolve([]);
  }

  displayFn(location?: any) {
    return location
      ? location.district ||
          location.department ||
          location.province ||
          location
      : undefined;
  }
}
